<template>
  <div class="im-list" :class="[{scroll: items.length > 10}]">
    <div class="im-list__header">
      <div
        v-if="title"
        class="im-list__title"
        @click="toggle"
      >
        {{ title }} ({{ count }})
      </div>
      <template v-if="selectable">
        <div
          class="im-list__all"
          @click="clickAllItems"
        >
          Всем
        </div>
      </template>
    </div>
    <div
      class="im-list__items"
      :class="[{open: isOpened}]"
    >
      <div class="im-list__items-wrapper">
        <div
          v-for="(item, index) in currentItems"
          :key="item.id"
          class="im-list__item"
          v-bind:class="'online-' + item.onlineStatus"
        >
          <div
            class="im-list__item-icon"
            v-bind:class="'online-' + item.onlineStatus"
          >
            <svg>
              <use xlink:href="#icon-user"></use>
            </svg>
          </div>
          <div
            class="im-list__item-text"
            v-bind:class="'online-' + item.onlineStatus"
            @click="clickItem(item)"
          >
            {{ item.name }}
            <template v-if="item.count">
              ({{ item.count }})
            </template>
          </div>
          <Checkbox
            class="im-list__checkbox"
            v-if="selectable"
            :checked="item.select"
            @change="changeItem(item, index, $event)"/>
        </div>
      </div>
      <div class="im-list__btn" v-show="isShowMore" @click="$emit('moreItems', id)">Показать ещё</div>
    </div>
  </div>
</template>

<script>
  import Checkbox from './checkbox/Checkbox.vue';

  export default {
    name: 'List',
    components: {
      Checkbox
    },
    props: {
      id: {
        type: Number,
        default: 0
      },
      opened: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default: function () {
          return [];
        }
      },
      count: {
        type: Number,
        default: 0
      },
      selectable: {
        type: Boolean,
        default: false
      },
      isShowMore: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOpened: true,
        currentItems: []
      };
    },
    computed: {
      selectedItems() {
        return this.currentItems.filter(item => item.select === true);
      }
    },
    watch: {
      items(value) {
        this.currentItems = value;
      }
    },
    mounted() {
      this.setItems();
      this.isOpened = this.opened;
    },
    methods: {
      setItems() {
        this.currentItems = this.items;
      },
      toggle() {
        this.isOpened = !this.isOpened;
        if(this.isOpened){
          this.$emit('openList', this.id);
        }
      },
      clickItem(item, index) {
        const list = this.getListData();
        const data = {
          index,
          item,
          list
        };
        this.$emit('clickItem', data);
      },
      changeItem(item, index, value) {
        item.select = value;
        const list = this.getListData();
        const data = {
          selectedItems: this.selectedItems,
          list
        };
        this.$emit('changeItem', data);
      },
      clickAllItems(value) {
        const MAGIC_ALL_ID = -999;
        let selectedItems = [
          {id: MAGIC_ALL_ID, name: 'Всем'}
        ];
        if (!value) {
          selectedItems = this.selectedItems;
        }
        const list = this.getListData();
        const data = {
          selectedItems: selectedItems,
          list
        };
        this.$emit('changeItems', data);
      },
      getListData() {
        return {
          index: this.index,
          id: this.id,
          title: this.title,
          items: this.items
        };
      },
    }
  };
</script>

<style lang="scss">
  .im-list {
    $root: &;
    border-top: 1px solid #DBDBDB;
    margin: 12px 0 0;
    padding: 12px 0 0;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 12px 0;
    }

    &__title {
      font-size: 12px;
      font-weight: bold;
      word-break: break-word;

      &:hover {
        cursor: pointer;
        color: #1588E2;
      }
    }

    &__all {
      font-size: 10px;
      color: #242A32;
      margin-left: 10px;

      &:hover {
        cursor: pointer;
        color: #1588E2;
      }

      &.hide {
        display: none;
      }
    }

    &__items {
      display: none;
      overflow: hidden;

      &::-webkit-scrollbar {
        width: 4px;

        &-track {
          background: #FFFFFF;
        }

        &-thumb {
          background: #C6CBD0;
          border-radius: 2px;
        }
      }

      &.open {
        display: block;
      }
    }

    &__item {
      display: flex;
      align-items: center;
      margin: 0 0 10px 0;

      &:last-child {
        margin-bottom: 0
      }
    }

    &__item-icon {
      width: 20px;
      height: 20px;

      svg {
        fill: #C6CBD0;
        width: 20px;
        height: 20px;
      }

      &.online-1 {
        svg {
          fill: #36B274;
        }
      }

      &.online-2 {
        svg {
          fill: #1588E2;
        }
      }
    }

    &__item-text {
      margin: 0 0 0 10px;
      width: calc(100% - 40px);
      color: #242A32;
      word-break: break-word;

      &.online-3 {
        color: #77808C;
      }

      &:hover {
        cursor: pointer;
        color: #1588E2;
      }
    }

    &__checkbox {
      &.hide {
        display: none;
      }
    }

    &__btn {
      background: #1588E2;
      border: 1px solid #D6D6D6;
      border-radius: 2px;
      margin: 16px 8px 0 0;
      padding: 8px 16px;
      font-size: 13px;
      line-height: 15px;
      text-align: center;
      color: #FFF;
      cursor: pointer;
    }

    &.scroll {
      #{$root}__items {
        width: calc(100% + 14px);
        height: 300px;
        overflow-y: auto;
      }

      #{$root}__item {
        margin-right: 10px;
      }
    }
  }
</style>